/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setToast } from '../../store/ToastManagement';
import {
  Divider,
  Grid,
  Header,
  Segment,
  Table,
  Button,
  Modal,
  Icon,
  Input,
  Dropdown,
  TextArea,
  Accordion,
  Checkbox
} from 'semantic-ui-react';
import { useCurrentUser, servicesAPI, uploadFile } from '../../_services';
import { copyToClipboard, dbUTCDatetimeToLocalTime } from '../../utils';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';

const moment = extendMoment(Moment);

const Config = require('../../conf');


const EMAIL_TEMPLATE_SURVEY_ASSESSMENT_COMPLETED = 'd-cac7cc71d43f4d3cb5a259f9db1d4025';

export const DisplayAonSurvey = ({ history, location }) => {
  const { currentUser, currentUserCan } = useCurrentUser();
  const surveyId = location.pathname.split('/')[4];
  const customerId = surveyId.replace('AONSurvey_', '');

  const [survey, setSurvey] = useState(null);
  const [surveyUrl, setSurveyUrl] = useState(null);
  const [media, setMedia] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [address, setAddress] = useState('');
  const [signUpState, setSignUpState] = useState(null);
  const [aonHost, setAonHost] = useState(null);
  const [commencedService, setCommencedService] = useState(null);

  const [installationInvoice, setInstallationInvoice] = useState(null);
  const [installationAmount, setInstallationAmount] = useState(0);
  const [selectedInvoicePDFFile, setSelectedInvoicePDFFile] = useState(null);

  const [summaryHide, setSummaryHide] = useState(false);
  const [additionalWorksHide, setAdditionalWorksHide] = useState(false);
  const [responsesHide, setResponsesHide] = useState(false);
  const [mediaHide, setMediaHide] = useState(false);

  const [openStatus, setOpenStatus] = useState(false);
  const [openENA, setOpenENA] = useState(false);

  const dispatch = useDispatch();
  const displayMessage = (title, message, success) =>
    dispatch(
      setToast({
        title: title,
        success: success,
        body: message
      })
    );

  const getSignUpState = () => {
    servicesAPI
      .AdminServices('getEntityState', 'AON_SIGN_UP', customerId)
      .then(state => {
        setSignUpState(state);

        if (!state) return;

        setSurveyUrl(state.survey_url);
        setInstallationAmount(state.installation_supplemental_payment_pounds);
      });
  };

  const getAonHost = () => {
    servicesAPI.CustomerServices('getAonHost', customerId).then(aonHost => {
      setAonHost(aonHost);
      setCommencedService(aonHost?.service_commencement_date);
    });
  };

  async function getSurvey() {
    try {
      let survey = await servicesAPI.AdminServices('getSurvey', surveyId, null, null);

      if (survey) {
        survey = {
          ...JSON.parse(survey.data),
          ...survey
        };
        setSurvey(survey);

        setCanEdit(survey.status !== 'IN_PROGRESS');

        servicesAPI.AdminServices('listFiles', `aonSurveySLASH${survey.id}`).then(files => {
          const media = files.filter(f => {
            const mediaName = f.name.substring(f.name.lastIndexOf('/') + 1).split('.')[0];

            // Separate survey photos & videos from invoice PDF
            const isInstallationInvoice = mediaName === 'InstallationInvoice';
            if (isInstallationInvoice) setInstallationInvoice(f);

            return !isInstallationInvoice;
          });

          setMedia(media);
        });
      }

      servicesAPI.CustomerServices('getById', customerId).then(customer => {
        setCustomer(customer);

        let address = [];
        if (customer.address_line1) address.push(customer.address_line1);
        if (customer.address_line2) address.push(customer.address_line2);
        if (customer.address_city) address.push(customer.address_city);
        if (customer.address_country_region) address.push(customer.address_country_region);
        if (customer.address_county) address.push(customer.address_county);
        if (customer.address_postcode) address.push(customer.address_postcode);

        setAddress(address.join(', '));
      });
    } catch (error) {}
  }

  const updateSurvey = () => {
    // AONTODO there is an approveCustomer() method but no rejectCustomer()
    if (survey.status === 'APPROVED') {
      // Flag conversion status as approved
      servicesAPI.CustomerServices('setConversionStatus', customerId, { new_conversion_status: 'EOI_APPROVED' });
    } else if (survey.status === 'REJECTED') {
      // Flag conversion status as rejected
      servicesAPI.CustomerServices('setConversionStatus', customerId, { new_conversion_status: 'EOI_TROJAN_REJECTED' });
    }

    const values = {
      status: survey.status,
      project_reference: survey.project_reference,
      tag_number: survey.tag_number,
      tag_reference: survey.tag_reference,
      further_investigation_required: survey.further_investigation_required,
      issued_to_local_authority: survey.issued_to_local_authority,
      ena_connect_status: survey.ena_connect_status,
      notes: survey.notes
    };
    servicesAPI.AdminServices('updateSurvey', surveyId, values);
    displayMessage('Success', `Changes saved`, true);
  }

  const commenceAonService = () => {
    servicesAPI.CustomerServices('commenceAonService', customerId).then(response => {
      getAonHost();
      displayMessage('Success', `Customer's HOME service has commenced`, true);
    });
  }

  const uploadInvoice = () => {
    // Upload invoice to survey folder
    const file = selectedInvoicePDFFile[0];
    const re = /(?:\.([^.]+))?$/;
    const ext = re.exec(file.name)[1];

    const folder = 'aonSurvey/' + surveyId;
    const fileData = selectedInvoicePDFFile[0];
    const fileName = 'InstallationInvoice.pdf';

    uploadFile(fileData, fileName, folder, () => {
      // Reload survey files to get PDF for display
      getSurvey();
    });
  };

  const approveCustomer = installationAmount => {
    servicesAPI
      .AdminServices('getEntityState', 'AON_SIGN_UP', customerId)
      .then(state => {
        if (!state) return;

        state.installation_supplemental_payment_pounds = installationAmount;
        state.approved_for_aon = true;

        // If no additional payment required, mark it as paid
        if (installationAmount === 0) {
          state.installation_supplemental_payment_paid = true;

          servicesAPI.AdminServices('sendMail', {
            email_recipient: 'support@trojan.energy',
            email_subject: 'HOME signup complete',
            email_body: `<div>Customer ${customerName} has completed their HOME sign-up.</div>`
          });
        }

        servicesAPI.AdminServices('upsertEntityState', 'AON_SIGN_UP', customerId, state);

        setSignUpState(state);
      });

    // Flag conversion status as approved
    servicesAPI.CustomerServices('setConversionStatus', customerId, { new_conversion_status: 'EOI_APPROVED' });

    // Sync supplemental payment via contract due to race condition where
    // customer can overwrites sign-up state after Civils team updates it
    servicesAPI.AdminServices('getContract', customerId).then(contract => {
      contract.installation_payment_amount = installationAmount * 100;
      servicesAPI.AdminServices('updateContract', customerId, contract);
    });

    servicesAPI.AdminServices(
      'auditUserActivity',
      {
        entity_type: 'CUSTOMER',
        entity_id: customer.id,
        activity: 'AONSurveyAssessmentCompleted',
        notes: 'HOME signup: Survey assessment completed and customer notified',
        email_recipient: customer.email,
        email_template_id: EMAIL_TEMPLATE_SURVEY_ASSESSMENT_COMPLETED,
        email_template_data: {
          url: Config.Local().portal_url + '/customer/dashboard'
        }
      },
      currentUser.id
    );

    displayMessage('Success', `Customer account updated (additional works = £${installationAmount}), and email notification sent`, true);
  };

  const setCardRegisteredOnCustomerDashboard = () => {
    servicesAPI
      .AdminServices('getEntityState', 'AON_SIGN_UP', customerId)
      .then(state => {
        if (!state) return;

        state.stripe_card_setup = true;

        servicesAPI.AdminServices('upsertEntityState', 'AON_SIGN_UP', customerId, state);
      });

    displayMessage('Success', `Card marked as registered on customer dashboard`, true);
  };

  const submitBlankSurvey = () => {
    const surveyId = 'AONSurvey_' + customerId;

    servicesAPI.AdminServices('getAonSurvey', customerId, null).then(survey => {
      const datetime = moment().format('YYYY-MM-DDTHH:mm:00') + ',Z';
      const values = {
        id: surveyId,
        datetime: datetime,
        auth: survey.auth,
        customer_id: customerId,
        responses: [{
          name: 'PLACEHOLDER_SURVEY',
          type: 'TEXT_PHOTO',
          question: 'Skipped survey. Performed outside of portal',
          response: '',
          status: 'ACTIVE'
        }]
      };

      servicesAPI.AdminServices('upsertSurvey', values, 'PLACEHOLDER' + surveyId).then(
        response => {
          displayMessage('Success', 'Submitted blank survey.', true);
        },
        error => {
          displayMessage('Error', 'Failed to submit blank survey.', false);
        }
      );
    });
  };

  const surnameToProjectName = surname => {
    return surname.replace(/[^a-z]/gi, '').toUpperCase();
  };

  const generateProjectReference = () => {
    if (!survey || !customer?.surname) return;

    const values = {
      tag_type: 'HOME',
      project_name: surnameToProjectName(customer.surname),
      approval_status: survey.status,
      local_authority: signUpState.local_authority,
      street: customer.address_line1,
      post_code: customer.address_postcode
    };

    servicesAPI.AdminServices('upsertTagApproval', values).then(tagApproval => {
      setSurvey({
        ...survey,
        project_reference: tagApproval.project_reference,
        tag_number: tagApproval.tag_number,
        tag_reference: tagApproval.tag_reference
      });

      // Auto-save project ref.
      const values = {
        status: survey.status,
        project_reference: tagApproval.project_reference,
        tag_number: tagApproval.tag_number,
        tag_reference: tagApproval.tag_reference
      };
      servicesAPI.AdminServices('updateSurvey', surveyId, values);
    });
  };

  useEffect(() => {
    getSurvey();
    getSignUpState();
    getAonHost();
  }, []);

  if (!customer) return <div>Loading...</div>;

  return (
    <Segment>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <Header as="h1">Trojan Home Survey: {customer.forename + ' ' + customer.surname}</Header>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden />
      <Accordion>
        <Accordion.Title
          active={!summaryHide}
          index={0}
          onClick={() => {
            setSummaryHide(!summaryHide);
          }}
        >
          <Header as="h2">
            <Icon name="dropdown" />
            Summary
          </Header>
        </Accordion.Title>
        <Accordion.Content active={!summaryHide}>
          <br />
          <Grid>
            <Table basic="very" celled fixed>
              <Table.Body>
                {survey ? (
                  <Table.Row>
                    <Table.Cell style={{ width: '200px' }}><b>Submitted</b></Table.Cell>
                    <Table.Cell>{survey.datetime}</Table.Cell>
                  </Table.Row>
                ) : ''}
                <Table.Row>
                  <Table.Cell><b>Customer name</b></Table.Cell>
                  <Table.Cell>{customer.forename + ' ' + customer.surname}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell><b>Address</b></Table.Cell>
                  <Table.Cell>{address}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell></Table.Cell>
                  <Table.Cell>
                    <Button
                      onClick={() => {
                        window.open(`https://maps.google.com/?q=${address}`, '_blank').focus();
                      }}
                      color="olive"
                    >
                      View address in Google Maps
                    </Button>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell></Table.Cell>
                  <Table.Cell>
                    <Button
                      onClick={() => {
                        window.open(`https://maps.google.com/maps?q=&layer=c&cbll=${customer?.lat_lon[0]},${customer?.lat_lon[1]}&cbp=12,0,0,0,0`, '_blank').focus();
                      }}
                      color="olive"
                    >
                      View address in Google Street View
                    </Button>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell></Table.Cell>
                  <Table.Cell>
                    <Button
                      onClick={() => {
                        copyToClipboard(customer.address_postcode);
                        window.open(`https://www.gov.uk/find-local-council`, '_blank').focus();
                      }}
                      color="olive"
                    >
                      Copy postcode & find local council
                    </Button>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell><b>Phone</b></Table.Cell>
                  <Table.Cell>{customer.mob_tel_no}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell><b>Email</b></Table.Cell>
                  <Table.Cell>{customer.email}</Table.Cell>
                </Table.Row>
                {survey ? (
                  <>
                    <Table.Row>
                      <Table.Cell><b>Status</b></Table.Cell>
                      <Table.Cell>
                        <Dropdown
                          selection
                          options={[
                            { text: "Submitted", value: 'SUBMITTED' },
                            { text: "Approved", value: 'APPROVED' },
                            { text: "Rejected", value: 'REJECTED' }
                          ]}
                          onChange={(e, inputProps) => setSurvey({
                            ...survey,
                            status: inputProps.value
                          })}
                          value={survey.status}
                          onOpen={() => setOpenStatus(true)}
                          onClose={() => setOpenStatus(false)}
                        />
                        {/* HACK for Semantic UI bug displaying elements in front of dropdown */}
                        {openStatus ? (
                          <>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                          </>
                        ) : (
                          ''
                        )}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell><b>Project Ref.</b></Table.Cell>
                      <Table.Cell>
                        {survey.project_reference ? survey.project_reference : (
                          <Button
                            onClick={() => generateProjectReference()}
                            color="olive"
                            disabled={!canEdit}
                          >
                            Generate new project reference
                          </Button>
                        )}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell><b>Further investigation required</b></Table.Cell>
                      <Table.Cell>
                        <Checkbox
                          checked={survey.further_investigation_required}
                          onChange={e => setSurvey({
                            ...survey,
                            further_investigation_required: !survey.further_investigation_required
                          })}
                        />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell><b>Issued to LA for approval</b></Table.Cell>
                      <Table.Cell>
                        <Checkbox
                          checked={survey.issued_to_local_authority}
                          onChange={e => setSurvey({
                            ...survey,
                            issued_to_local_authority: !survey.issued_to_local_authority
                          })}
                        />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell><b>ENA connect status</b></Table.Cell>
                      <Table.Cell>
                        <Dropdown
                          selection
                          options={[
                            { text: "Submitted", value: 'SUBMITTED' },
                            { text: "Approved", value: 'APPROVED' },
                            { text: "Escalated to DNO", value: 'ESCALATED_TO_DNO' }
                          ]}
                          onChange={(e, inputProps) => setSurvey({
                            ...survey,
                            ena_connect_status: inputProps.value
                          })}
                          value={survey.ena_connect_status}
                          onOpen={() => setOpenENA(true)}
                          onClose={() => setOpenENA(false)}
                        />
                        {/* HACK for Semantic UI bug displaying elements in front of dropdown */}
                        {openENA ? (
                          <>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                          </>
                        ) : (
                          ''
                        )}
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell><b>Comments</b></Table.Cell>
                      <Table.Cell>
                        <Segment style={{ width: '630px' }}>
                          <TextArea
                            value={survey.notes}
                            onChange={(e, inputProps) => setSurvey({
                              ...survey,
                              notes: inputProps.value
                            })}
                            style={{ width: '600px', height: '200px' }}
                          />
                        </Segment>
                      </Table.Cell>
                    </Table.Row>
                  </>
                ) : ''}
              </Table.Body>
            </Table>
          </Grid>
          <br />
          {survey ? (
            <>
              <Button
                onClick={() => updateSurvey()}
                color="olive"
                disabled={!currentUserCan('ManageAON') || commencedService}
              >
                Save changes
              </Button>
            </>
          ) : ''}
          <Divider />
        </Accordion.Content>
      </Accordion>
      {survey ? (
        <>
          <Accordion>
            <Accordion.Title
              active={!additionalWorksHide}
              index={0}
              onClick={() => {
                setAdditionalWorksHide(!additionalWorksHide);
              }}
            >
              <Header as="h2">
                <Icon name="dropdown" />
                Installation Additional Works
              </Header>
            </Accordion.Title>
            <Accordion.Content active={!additionalWorksHide}>
              <br />
              <Grid>
                <Table basic="very" celled fixed>
                  <Table.Body>
                    <Segment style={{ width: '420px' }}>
                      <Input
                        type="number"
                        label={'Additional Works Amount (£)'}
                        value={installationAmount}
                        onChange={(e, inputProps) =>
                          setInstallationAmount(Math.max(parseInt(inputProps.value), 0))
                        }
                      />
                      <Button
                        onClick={() => setInstallationAmount(installationAmount)}
                        color="olive"
                        disabled={!currentUserCan('ManageAON') || commencedService}
                      >
                        Set Additional Works Amount
                      </Button>
                    </Segment>
                    <Segment style={{ width: '420px' }}>
                      <label for="file-upload" className="aon-custom-file-upload">
                        {(selectedInvoicePDFFile && selectedInvoicePDFFile.length) ? selectedInvoicePDFFile[0].name : 'Select Invoice PDF to Upload'}
                      </label>
                      <input
                        id="file-upload"
                        className="aon-file-upload"
                        type="file"
                        accept=".pdf"
                        onChange={event => setSelectedInvoicePDFFile(event.target.files)}
                      />
                      <br />
                      <Button
                        onClick={() => uploadInvoice()}
                        color="olive"
                        disabled={!currentUserCan('ManageAON') || commencedService || !selectedInvoicePDFFile || !selectedInvoicePDFFile.length}
                      >
                        Upload Invoice
                      </Button>
                    </Segment>
                    <br />
                    <Button
                      onClick={() => approveCustomer(installationAmount)}
                      color="olive"
                      disabled={!currentUserCan('ManageAON') || commencedService}
                    >
                      Update Account & Notify Customer
                    </Button>
                    <br />
                    <br />
                    {installationInvoice ? ( <iframe src={installationInvoice.url} width="100%" height="800px"></iframe> ) : ''}
                    <br />
                    {!commencedService ? (
                      <Button
                        onClick={() => commenceAonService()}
                        color="olive"
                        disabled={!currentUserCan('ManageAON') || commencedService || !signUpState?.approved_for_aon}
                      >
                        Commence the HOME Service
                      </Button>
                    ) : (
                      <b>Service commenced on {dbUTCDatetimeToLocalTime(commencedService)}</b>
                    )}
                    <br />
                    <br />
                  </Table.Body>
                </Table>
                <br />
                <br />
              </Grid>
            </Accordion.Content>
          </Accordion>
          <Accordion>
            <Accordion.Title
              active={!responsesHide}
              index={0}
              onClick={() => {
                setResponsesHide(!responsesHide);
              }}
            >
              <Header as="h2">
                <Icon name="dropdown" />
                Responses
              </Header>
            </Accordion.Title>
            <Accordion.Content active={!responsesHide}>
              <br />
              <Grid>
                <Table basic="very" celled fixed>
                  <Table.Body>
                    {survey.responses.map(r => {
                      if (!r) return <></>;
                      if (r.type === 'SELECT') {
                        return (
                          <Table.Row key={1}>
                            <Table.Cell>{r.question}</Table.Cell>
                            <Table.Cell>{r.response}</Table.Cell>
                          </Table.Row>
                        );
                      } else if (r.type === 'TEXT') {
                        return (
                          <Table.Row key={1}>
                            <Table.Cell>{r.question}</Table.Cell>
                            <Table.Cell>{r.response}</Table.Cell>
                          </Table.Row>
                        );
                      } else if (r.type === 'NUMBER') {
                        return (
                          <Table.Row key={1}>
                            <Table.Cell>{r.question}</Table.Cell>
                            <Table.Cell>{r.response}</Table.Cell>
                          </Table.Row>
                        );
                      } else if (r.type === 'TEXT_PHOTO_VIDEO' || r.type === 'TEXT_PHOTO') {
                        return (
                          <Table.Row key={1}>
                            <Table.Cell>{r.question}</Table.Cell>
                            <Table.Cell>{r.response.text}</Table.Cell>
                          </Table.Row>
                        );
                      }

                      return <></>;
                    })}
                  </Table.Body>
                </Table>
              </Grid>
              <Divider />
            </Accordion.Content>
          </Accordion>
          <Accordion>
            <Accordion.Title
              active={!mediaHide}
              index={0}
              onClick={() => {
                setMediaHide(!mediaHide);
              }}
            >
              <Header as="h2">
                <Icon name="dropdown" />
                Photos & Videos
              </Header>
            </Accordion.Title>
            <Accordion.Content active={!mediaHide}>
              <br />
              {media.map(
                m => {
                  const mediaName = m.name.substring(m.name.lastIndexOf('/') + 1).split('.')[0];
                  const response = survey.responses.find(r => r?.name === mediaName);
                  if (!response) return;

                  if (['UPLOAD_PHOTO', 'UPLOAD_PHOTOS'].includes(response.type)) {
                    return (
                      <>
                        <figure>
                          <figcaption style={{ fontSize: '18px' }}>{response?.question}</figcaption>
                          <img src={m.url} alt="photo" style={{ maxWidth: '1000px', height: 'auto', width: 'auto' }} />
                        </figure>
                        <br />
                      </>
                    );
                  } else if (response.type === 'UPLOAD_VIDEO') {
                    return (
                      <>
                        <figure>
                          <figcaption style={{ fontSize: '18px' }}>{response?.question}</figcaption>
                          <video
                            src={m.url}
                            alt="video"
                            style={{ maxWidth: '1000px', height: 'auto', width: 'auto' }}
                            controls
                          />
                        </figure>
                        <br />
                      </>
                    );
                  } else {
                    const extension = m.name.split('.').pop();
                    const isImage = ['gif', 'jpg', 'jpeg', 'png'].includes(extension);
                    const isVideo = ['mpg', 'mp2', 'mpeg', 'mpe', 'mpv', 'mp4', 'mov'].includes(extension);

                    if (isImage) {
                      return (
                        <>
                          <figure>
                            <figcaption style={{ fontSize: '18px' }}>{response?.question}</figcaption>
                            <img src={m.url} alt="photo" style={{ maxWidth: '1000px', height: 'auto', width: 'auto' }} />
                          </figure>
                          <br />
                        </>
                      );
                    } else if (isVideo) {
                      return (
                        <>
                          <figure>
                            <figcaption style={{ fontSize: '18px' }}>{response?.question}</figcaption>
                            <video
                              src={m.url}
                              alt="video"
                              style={{ maxWidth: '1000px', height: 'auto', width: 'auto' }}
                              controls
                            />
                          </figure>
                          <br />
                        </>
                      );
                    }
                  }
                }
              )}
              <Divider />
            </Accordion.Content>
          </Accordion>
        </>
      ) : (
        <>
          <Button
            onClick={() => {
              window.open(surveyUrl, '_blank').focus();
            }}
            color="olive"
            disabled={!currentUserCan('ManageAON')}
          >
            Perform survey
          </Button>
          <br />
          <br />
          <Button
            onClick={() => submitBlankSurvey()}
            color="olive"
            disabled={!currentUserCan('ManageAON')}
          >
            Skip survey and move to Submitted list
          </Button>
        </>
      )}
    </Segment>
  );
};
